import React, { useEffect, useState } from 'react';
import { ServerEntitySelectorEmbedded } from '@bingads-webui-fluent-component/entity-selector';

import { useGoalSelectorState } from './use-goal-selector-state';
import { GoalSelectorConfigProps } from './types';
import { fetchConversionGoalFactory } from './data';
import { TableViewSection } from './table-view-section';
import { EMPTY_STATE, Scopes } from './constants';
import { EmptyStateResultComponent } from './components/empty-state-result';

export const GoalSelector: React.FC<(GoalSelectorConfigProps)> = ({
  i18n,
  cid,
  aid,
  value: valueFromProps,
  onChange: onChangeFromProps,
  goalScopeSelection,
  isCreationWorkflow,
  activityLogger,
  ...props
}) => {
  const [scope, setScope] = useState(goalScopeSelection);
  const [emptyStateNoGoal, setEmptyStateNoGoal] = useState(false);

  const fetchData = fetchConversionGoalFactory({
    options: scope === Scopes.ACCOUNT ? { filter: ' and (IsMainConversionGoal eq true)' } : {},
    cid,
    aid,
  });

  const onSetScope = (newScope) => {
    if (activityLogger && activityLogger.trace) {
      activityLogger.trace(`[GoalSelectorV3] goal scope change: ${newScope}`);
    }
    onChangeFromProps({
      goalScopeSelection: newScope,
    });

    setScope(newScope);
  };

  const onChangeGoalSelector = (items) => {
    onChangeFromProps({
      goalSelection: items,
    });
  };

  useEffect(() => {
    fetchConversionGoalFactory({ cid, aid })({
      page: 1, pageSize: 5, search: '', sortState: null,
    }).then((response) => {
      if (response && response.count === 0) {
        setEmptyStateNoGoal(true);
      }
    });
  }, [aid, cid]);

  const { value, onChange } = useGoalSelectorState({ value: valueFromProps, onChange: onChangeGoalSelector });
  if (emptyStateNoGoal) {
    return <div className="goal-selector-v3"> <EmptyStateResultComponent i18n={i18n} emptyState={EMPTY_STATE.NoGoalInitial} isCreationWorkflow={isCreationWorkflow} activityLogger={activityLogger} /></div>;
  }
  return (
    <>
      <ServerEntitySelectorEmbedded
        {...props}
        i18n={i18n}
        className="goal-selector-v3"
        fetchData={fetchData}
        value={value}
        onChange={onChange}
        childrenProps={
        {
          i18n,
        }
      }
      >
        <TableViewSection i18n={i18n} scope={scope} isCreationWorkflow={isCreationWorkflow} activityLogger={activityLogger} setScope={onSetScope} />
      </ServerEntitySelectorEmbedded>
    </>
  );
};
